import { listTopLevelFolders } from '~lib/storage/abs-client';
import { epflContainer } from '~lib/storage/config';

// A top-level folder of data under the `epfl` container. These are not
// catalogue datasets and are intentionally never enumerated — they can be
// huge — so a folder is just its name plus the container-relative path used
// to mount it (e.g. `epfl/CellDensities`).
export interface EpflFolder {
  name: string;
  path: string;
}

export async function loadEpflFolders(token: string): Promise<EpflFolder[]> {
  const names = await listTopLevelFolders(token, epflContainer);
  return names.map((name) => ({ name, path: `${epflContainer}/${name}` }));
}
